import { Outlet, Link, useNavigate } from "react-router-dom";
import "./frontendHeader.css";
import "../../css/style.css";
import "../../../../index.css"
import { useLocation } from "react-router-dom";
import FrontendFooter from "../frontendFooter/FrontendFooter";
import Icon from "@mui/material/Icon";
import { useEffect, useState } from "react";
import store from "../../../../store";
import { logOut } from "../../../login/Login_reducer";
import { Cookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid } from "@mui/material";
import DashboardIcon from '@mui/icons-material/Dashboard';
import Tooltip from '@mui/material/Tooltip';
import { setProductAccessOfShop } from "../../../dashboard/userDashboardReducer";




function FrontendHeader() {

  const [isLoggedIn, setIsLoggedIn] = useState(store.getState().loginUserKey.isLoggedIn);
  const [store_Access, setStore_Access] = useState(store.getState().userDashboardKey.store_access);

  console.log("Frontend header console")
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  let userType = useSelector((state) => state.loginUserKey?.userInfo?.type?.replaceAll('_', '-'))





  useEffect(() => {
    console.log('Location changed', location, location.pathname);
  }, [location]);

  useEffect(() => {
    console.log('store_Access useeffect', store_Access);
  }, [store_Access]);

  useEffect(() => {
    const classExists = document.querySelector('.blackBg') !== null;

    if (classExists) document.body.classList.add('bodyclass');
    else document.body.classList.remove('bodyclass');
  }, [location]);

  const showMenuBar = () => {
    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");

  };


  const showMenuBarSub = () => {
    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");

  };

  const dispatch = useDispatch();
  const navigate = useNavigate();


  store.subscribe(() => {
    const storedata = store.getState();
    setIsLoggedIn(storedata.loginUserKey.isLoggedIn);
    setStore_Access(store.getState().userDashboardKey.store_access);

  });

  const bukUrl = "https://d37pbainmkhx6o.cloudfront.net/fryright_images"

  const Images = [
    "logo.png"

  ];


  return (
    <>

      {isLoggedIn ? (<Button className="goToAdmin"> <Link to={`/${userType}-dashboard`}>  <Tooltip title={`Dashboard`} >
        <DashboardIcon />
      </Tooltip> </Link>  </Button>) : ("")}

      {/* <Button  className="goToAdmin"> <Link to="/admin-dashboard">  <Tooltip title="Admin Dashboard" >
      <DashboardIcon/>
    </Tooltip> </Link>  </Button> */}




      <div className="menu_block">
        <div className="menu_left">
          <div className="top_logo">
            <span className="menu_logo" >
              <a href="/home">
                {/***<img src="https://d37pbainmkhx6o.cloudfront.net/fryright_images/logo.png" />***/}
                <img src={`${bukUrl}/${Images[0]}`} />
              </a>
            </span>

            <span className="mobilemenu" onClick={showMenuBar}>
              <Icon className="toggleMenu">clear_all</Icon>
            </span>
          </div>

          <div className="top_menu topMenuLists" id="topMenuLists">
            <ul className="menulistwrapper">
              <li onClick={showMenuBarSub} className={splitLocation[1] === "home" ? "active" : ""} >
                {" "}
                <Link to="/home"> Home </Link>{" "}
              </li>{" "}

             

              <li onClick={showMenuBarSub}
                className={
                  splitLocation[1] === "the-fry-right-system" ? "active" : ""
                }
              >
                <Link to="/the-fry-right-system">
                  {" "}
                  The Fry Right System{" "}
                </Link>{" "}
              </li>{" "}
             

              <li onClick={showMenuBarSub} className={splitLocation[1] === "testimonials" ? "active" : ""}>
                <Link to="/testimonials">Testimonials </Link>{" "}
              </li>{" "}

              <li onClick={showMenuBarSub} className={splitLocation[1] === "about-us" ? "active" : ""}>
                <Link to="/about-us">About </Link>{" "}
              </li>{" "}

             


              {/* {(store_Access === null || store_Access == 1) &&
                <li onClick={showMenuBarSub} className={splitLocation[1] === "product" ? "active" : ""}>
                  <Link to="/product">Cart</Link>
                </li>
              } */}

              <li onClick={showMenuBarSub} className={splitLocation[1] === "contact" ? "active" : ""}>
                {" "}
                <Link to="/contact"> Contact </Link>{" "}
              </li>{" "}

              <li onClick={showMenuBarSub} className={splitLocation[1] === "blog" ? "active" : ""}>
                {" "}
                <Link to="/blog"> Blog </Link>{" "}
              </li>{" "}
              

            </ul>
          </div>

          <div className="menu_right">
            <span className="tell_block">
              <a href="tel:208-270-0097">208-270-0097</a>
            </span>

            <span className="emil_block">
              {" "}
              <a href="mailto:fryright@gmail.com">fryright@gmail.com</a>
            </span>
            {isLoggedIn ? (
              <>
                <span
                  className="Login_block"
                  onClick={() => {
                    dispatch(logOut());
                    dispatch(setProductAccessOfShop({ store_access: null }))
                    const cookies = new Cookies();
                    cookies.remove("userInfo", { path: "/" });
                    cookies.remove("secret", { path: "/" });
                    cookies.remove("token", { path: "/" });
                    cookies.remove("store_access", { path: "/" });
                    navigate("/", { replace: true });
                  }}
                >
                  <a>Log Out</a>
                </span>
              </>
            ) : (
              <span className="Login_block" onClick={() => navigate('/login', { replace: true })}>
                <a>Login</a>
              </span>
            )}
          </div>
        </div>
      </div>


      <Outlet />

      <FrontendFooter />
    </>
  );
}

export default FrontendHeader;
